import {useEffect, useRef} from "react";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";

const IP_API_URL = "https://api.sypexgeo.net/";

const TOAST_OPTIONS = {
  position: "bottom-right" as const,
  autoClose: false as const,
  hideProgressBar: true,
  closeButton: true,
};

interface IpApiResponse {
  region: {
    timezone?: string;
  }
}

function VPNDetectorToast() {
  const {t} = useTranslation();
  const hasShownToast = useRef(false);

  useEffect(() => {
    let cancelled = false;

    async function checkTimezoneMismatch() {
      try {
        const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const response = await fetch(IP_API_URL);
        const data: IpApiResponse = await response.json();

        if (cancelled || hasShownToast.current) return;

        const ipTimezone = data.region.timezone;
        if (ipTimezone && browserTimezone !== ipTimezone) {
          hasShownToast.current = true;
          toast.warn(t("vpnDetected.message"), TOAST_OPTIONS);
        }
      } catch (err) {
        if (!cancelled) console.error("VPN check api not working", err);
      }
    }

    checkTimezoneMismatch();
    return () => {
      cancelled = true;
    };
  }, [t]);

  return null;
}

export default VPNDetectorToast;
